import { useEffect } from 'react';
import { useAsyncAction } from './useAsyncAction';

export function useAsync<T>(
  action: () => Promise<T | undefined>,
  dependencies: unknown[]
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const { data, error, loading, perform } = useAsyncAction(action, dependencies);

  useEffect(() => {
    perform();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return { data, loading, error, reload: perform };
}
